import { Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { CaptchaApi } from "../api/captcha-api";
import { catchErrorWithDispatch } from "../libs/utils/errors";
import { CaptchaActions } from "../redux/captcha/actions";
import { LoadCaptcha, LoadCaptchaDone } from "../redux/captcha/actions/default";
import { PageValidateChannelsAction } from "../redux/page/actions/default";

export class CaptchaRepository {
    static validateCaptcha(action: LoadCaptcha): Observable<CaptchaActions> {
        const { token, codApplication } = action.payload;
        return CaptchaApi.captcha(token, codApplication).pipe(
            switchMap(() =>
                of(
                    new LoadCaptchaDone(true).create(),
                    new PageValidateChannelsAction().create()
                )
            ),
            catchErrorWithDispatch((err) =>
                of(new LoadCaptchaDone(err).create())
            )
        );
    }
}
